import { memo } from 'react';

import { Repeat2Icon } from '@air/design-icons';
import { Badge } from '@air/primitive-badge';

import { MainSideNavItem } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItem';
import { useMainSideNavItemSelected } from '~/components/v2/components/workspace/main-side-nav/useMainSideNavItemSelected';
import { Pathnames } from '~/components/v2/constants/pathnames';
import { useAutomationsAccess } from '~/hooks/useAutomationsAccess';

export type MainSideNavItemAutomationsProps = {
  pathname: string;
};

export const MainSideNavItemAutomations = memo(({ pathname }: MainSideNavItemAutomationsProps) => {
  const { showAutomationsChrome } = useAutomationsAccess();
  const { isSelected } = useMainSideNavItemSelected({
    isRouteSelected:
      pathname === Pathnames.Automations ||
      pathname === Pathnames.AutomationsNew ||
      pathname === Pathnames.AutomationsByAutomationId,
  });

  if (!showAutomationsChrome) {
    return null;
  }

  return (
    <MainSideNavItem
      href={Pathnames.Automations}
      icon={Repeat2Icon}
      id="automations"
      isSelected={isSelected}
      label={
        <span className="flex min-w-0 items-center gap-1.5">
          <span className="truncate">Automations</span>
          <Badge
            appearance="pill"
            className="shrink-0"
            color="gray"
            data-testid="MAIN_SIDE_NAV_ITEM_BETA_BADGE"
            size="small"
          >
            Beta
          </Badge>
        </span>
      }
      sidebarInteractionType="automations"
    />
  );
});

MainSideNavItemAutomations.displayName = 'MainSideNavItemAutomations';
